export default {
    searchText: 'Search by Name',
    search: 'Search',
    holidayName: 'Holiday Name',
    createdDate: 'Date create',
    holidayDate: 'Holiday date',
    action: '',
    addHoliday: 'Add Holiday',
    deleteHeader: 'Delete Holiday',
    wantToDelete: 'Are you sure you want to delete',
    congratulation: 'Congratulation',
    deletedHoliday: 'Holiday was deleted.'
}
